import React, { useEffect, useState } from "react";
import { Variables, variables } from '../../Variables.js';
import imageLogo from '../../img/logo.png';

function AssistsVsTeam(props) {

    const Data = props.data.gamestats;

    return (
        <div>
            <div className="props">
                <ul>
                    <li className="stat-list">
                        <div className="propOptions">
                            {(props.data.totGameCount > 0) && <h5>Assists</h5>}
                            {props.data.awayGameCount > 0 && <p className="games"><h4>Away (last {props.data.awayGameCount} games)</h4>
                                <span class="games_list">
                                    <p>Games</p>
                                    <ul>

                                        {Object.values(Data).map((item) => {
                                            if (item.home == false) {
                                                var dateString = item.gameID;
                                                var year = dateString.substring(0, 4);
                                                var month = dateString.substring(4, 6);
                                                var day = dateString.substring(6, 8);

                                                var game = dateString.substring(9, 16)
                                                return (<li className="stat-list"><a target="_blank" href={item.nbaComLink}>{month + "-" + day + "-" + year} {game}</a></li>)
                                            };
                                        })}

                                    </ul>
                                </span></p>
                            }
                            <div className="work-request--options">
                            <center>
                                {props.data.awayGameCount > 0 &&                           
                                    <span className="options-a">
                                        <label htmlFor="apg">
                                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                viewBox="0 0 150 111" xmlSpace="preserve">
                                                <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                                    <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                                </g>
                                            </svg>
                                            {props.data.away_ast_average} APG
                                        </label>

                                    </span>
                                 }
                            </center>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div className="props">
                <ul>
                    <li className="stat-list">
                        <div className="propOptions">
                            {props.data.homeGameCount > 0 && <p className="games"><h4>Home (last {props.data.homeGameCount} games)</h4>
                                <span class="games_list">
                                    <p>Games</p>
                                    <ul>

                                        {Object.values(Data).map((item) => {
                                            if (item.home == true) {
                                                var dateString = item.gameID;
                                                var year = dateString.substring(0, 4);
                                                var month = dateString.substring(4, 6);
                                                var day = dateString.substring(6, 8);

                                                var game = dateString.substring(9, 16)
                                                return (<li className="stat-list"><a target="_blank" href={item.nbaComLink}>{month + "-" + day + "-" + year} {game}</a></li>)
                                            };
                                        })}

                                    </ul>
                                </span></p>
                            }
                            <div className="work-request--options">
                            <center>
                                {props.data.homeGameCount > 0 &&
                                    <span className="options-a">
                                        <label htmlFor="apg">
                                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                                    viewBox="0 0 150 111" xmlSpace="preserve">
                                                <g transform="translate(0.000000,111.000000) scale(0.100000,-0.100000)">
                                                    <path d="M950,705L555,310L360,505C253,612,160,700,155,700c-6,0-44-34-85-75l-75-75l278-278L550-5l475,475c261,261,475,480,475,485c0,13-132,145-145,145C1349,1100,1167,922,950,705z" />
                                                </g>
                                            </svg>
                                            {props.data.home_ast_average} APG
                                        </label>
                                    </span>
                                 }
                            </center>
                            </div>
                         </div>
                    </li>
                </ul>
            </div>
        </div>
    )

};

export default AssistsVsTeam;

